/**
 * Блок «как робот торговал + проверьте сами» — на главной и страницах рынков.
 * Сначала факты (сделки робота из базы), потом ползунки: посетитель сам
 * двигает депозит, лот, тейк и число сделок и видит доход.
 */
export interface ShowcaseTranslations {
    title: string
    titleGlobal: string
    titleCrypto: string
    subtitle: string
    globalName: string
    globalWhat: string
    cryptoName: string
    cryptoWhat: string
    openCalculator: string
    guestNote: string
    disclaimer: string
}

const ru: ShowcaseTranslations = {
    title: 'Сколько зарабатывает робот',
    titleGlobal: 'Сколько робот зарабатывает на мировых биржах',
    titleCrypto: 'Сколько робот зарабатывает на криптобиржах',
    subtitle: 'Сначала — факты: сделки робота из нашей базы. Ниже — проверьте сами: двигайте ползунки и смотрите доход.',
    globalName: 'Мировые биржи',
    globalWhat: 'Фьючерсы на индекс S&P 500 через вашего брокера.',
    cryptoName: 'Криптобиржи',
    cryptoWhat: 'Криптовалюта на вашем счёте Bybit, Binance, OKX или Bitget.',
    openCalculator: 'Открыть полный калькулятор',
    guestNote: 'Регистрация бесплатная. Полный калькулятор и запуск робота — в личном кабинете.',
    disclaimer: 'Факты — прошлые сделки робота; будущий результат может отличаться. Торговля связана с риском.',
}

const en: ShowcaseTranslations = {
    title: 'How much the robot earns',
    titleGlobal: 'How much the robot earns on global exchanges',
    titleCrypto: 'How much the robot earns on crypto exchanges',
    subtitle: 'Facts first: the robot\'s trades from our database. Then check it yourself: move the sliders and see the income.',
    globalName: 'Global exchanges',
    globalWhat: 'S&P 500 index futures through your broker.',
    cryptoName: 'Crypto exchanges',
    cryptoWhat: 'Crypto on your Bybit, Binance, OKX or Bitget account.',
    openCalculator: 'Open the full calculator',
    guestNote: 'Sign-up is free. The full calculator and robot launch are in your account.',
    disclaimer: 'Facts are the robot\'s past trades; future results may differ. Trading involves risk.',
}

const es: ShowcaseTranslations = {
    title: 'Cuánto gana el robot',
    titleGlobal: 'Cuánto gana el robot en los mercados globales',
    titleCrypto: 'Cuánto gana el robot en los exchanges cripto',
    subtitle: 'Primero, los hechos: las operaciones del robot en nuestra base. Luego compruébelo usted: mueva los controles y vea el ingreso.',
    globalName: 'Mercados globales',
    globalWhat: 'Futuros del índice S&P 500 a través de su bróker.',
    cryptoName: 'Exchanges cripto',
    cryptoWhat: 'Cripto en su cuenta de Bybit, Binance, OKX o Bitget.',
    openCalculator: 'Abrir la calculadora completa',
    guestNote: 'El registro es gratis. La calculadora completa y el robot están en su cuenta.',
    disclaimer: 'Los hechos son operaciones pasadas del robot; el resultado futuro puede variar. Operar conlleva riesgo.',
}

const fr: ShowcaseTranslations = {
    title: 'Combien gagne le robot',
    titleGlobal: 'Combien le robot gagne sur les marchés mondiaux',
    titleCrypto: 'Combien le robot gagne sur les plateformes crypto',
    subtitle: 'D\'abord les faits : les trades du robot dans notre base. Puis vérifiez vous-même : bougez les curseurs et voyez le revenu.',
    globalName: 'Marchés mondiaux',
    globalWhat: 'Contrats à terme sur l\'indice S&P 500 via votre courtier.',
    cryptoName: 'Plateformes crypto',
    cryptoWhat: 'Crypto sur votre compte Bybit, Binance, OKX ou Bitget.',
    openCalculator: 'Ouvrir le calculateur complet',
    guestNote: 'L\'inscription est gratuite. Le calculateur complet et le robot sont dans votre compte.',
    disclaimer: 'Les faits sont des trades passés du robot ; le résultat futur peut différer. Le trading comporte des risques.',
}

const de: ShowcaseTranslations = {
    title: 'Wie viel der Roboter verdient',
    titleGlobal: 'Wie viel der Roboter an den Weltbörsen verdient',
    titleCrypto: 'Wie viel der Roboter an Kryptobörsen verdient',
    subtitle: 'Zuerst die Fakten: die Trades des Roboters aus unserer Datenbank. Dann selbst prüfen: Regler bewegen und den Ertrag sehen.',
    globalName: 'Weltbörsen',
    globalWhat: 'Futures auf den S&P-500-Index über Ihren Broker.',
    cryptoName: 'Kryptobörsen',
    cryptoWhat: 'Krypto auf Ihrem Bybit-, Binance-, OKX- oder Bitget-Konto.',
    openCalculator: 'Vollständigen Rechner öffnen',
    guestNote: 'Die Registrierung ist kostenlos. Rechner und Roboterstart im persönlichen Bereich.',
    disclaimer: 'Fakten sind vergangene Trades des Roboters; künftige Ergebnisse können abweichen. Handel ist mit Risiken verbunden.',
}

const it: ShowcaseTranslations = {
    title: 'Quanto guadagna il robot',
    titleGlobal: 'Quanto guadagna il robot sui mercati globali',
    titleCrypto: 'Quanto guadagna il robot sugli exchange crypto',
    subtitle: 'Prima i fatti: le operazioni del robot dal nostro database. Poi verifica tu: muovi i cursori e guarda il guadagno.',
    globalName: 'Mercati globali',
    globalWhat: 'Futures sull\'indice S&P 500 tramite il tuo broker.',
    cryptoName: 'Exchange crypto',
    cryptoWhat: 'Crypto sul tuo conto Bybit, Binance, OKX o Bitget.',
    openCalculator: 'Apri il calcolatore completo',
    guestNote: 'La registrazione è gratuita. Il calcolatore completo e il robot sono nel tuo account.',
    disclaimer: 'I fatti sono operazioni passate del robot; il risultato futuro può differire. Il trading comporta rischi.',
}

const hy: ShowcaseTranslations = {
    title: 'Որքան է վաստակում ռոբոտը',
    titleGlobal: 'Որքան է ռոբոտը վաստակում համաշխարհային բորսաներում',
    titleCrypto: 'Որքան է ռոբոտը վաստակում կրիպտոբորսաներում',
    subtitle: 'Նախ՝ փաստերը՝ ռոբոտի գործարքները մեր բազայից։ Հետո ստուգեք ինքներդ՝ շարժեք սահիչները և տեսեք եկամուտը։',
    globalName: 'Համաշխարհային բորսաներ',
    globalWhat: 'S&P 500 ինդեքսի ֆյուչերսներ ձեր բրոքերի միջոցով։',
    cryptoName: 'Կրիպտոբորսաներ',
    cryptoWhat: 'Կրիպտոարժույթ ձեր Bybit, Binance, OKX կամ Bitget հաշվում։',
    openCalculator: 'Բացել ամբողջական հաշվիչը',
    guestNote: 'Գրանցումն անվճար է։ Ամբողջական հաշվիչը և ռոբոտի գործարկումը՝ անձնական էջում։',
    disclaimer: 'Փաստերը ռոբոտի անցյալ գործարքներն են. ապագա արդյունքը կարող է տարբերվել։ Առևտուրը ռիսկ է պարունակում։',
}

const translations: Record<string, ShowcaseTranslations> = { ru, en, es, fr, de, it, hy }

export default translations
